import * as jsxRuntime from "/codebuild/output/src1396336581/src/github.com/OneBlinc/triton-react/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment